import axios from '@axios'

export const state = {
  banners: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecord: 0,
}

export const getters = {
  allBanners: (state) => state.banners,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  GET_BANNERS: (state, resp) => {
    if (!resp) return null
    state.banners = resp.banners
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_BANNER: (state, banner) => {
    state.banners.unshift(banner)
  },
  UPDATE_BANNERS: (state, banner) => {
    let clone = []
    for (let i = 0; i < state.banners.length; i++) {
      if (state.banners[i].id === banner.id) {
        clone[i] = banner
      } else {
        clone[i] = state.banners[i]
      }
    }
    state.banners = clone
  },
  DELTE_BANNERS: (state, banner) => {
    state.banners = state.banners.filter((s) => s.id !== banner.id)
  },
}

export const actions = {
  async getBanners({ commit }, params) {
    await axios
      .get(`/api/banners`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_BANNERS', data)
        }
      })
      .catch(() => {
        commit('GET_BANNERS', null)
      })
  },
  async createBanners({ commit }, banner) {
    return axios.post('/api/banners', banner)
  },
  async updateBanners({ commit }, banner) {
    return axios.put('/api/banners', banner)
  },
  async deleteBanners({ commit, dispatch }, bannerId) {
    await axios.delete(`/api/banners/${bannerId}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_BANNERS', bannerId)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The banner has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
}
